import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Css/PricingSingle.css';

const Pricing = () => {
    const features = [
        'Unlimited transactions',
        'AI contract analysis',
        'Smart task automation',
        'Client collaboration portal',
        'Email integration',
        'Analytics & reporting',
        'CRM integrations',
        'Mobile app access',
        'Priority support',
        'API access'
    ];

    const faqs = [
        {
            question: 'Is there a free trial?',
            answer: 'Yes! We offer a 14-day free trial with full access to all features. No credit card required to start.'
        },
        {
            question: 'Can I cancel anytime?',
            answer: 'Absolutely. There are no long-term contracts. You can cancel your subscription at any time with no questions asked.'
        },
        {
            question: 'What happens to my data if I cancel?',
            answer: 'Your data remains accessible for 30 days after cancellation. You can export all your transaction data at any time.'
        },
        {
            question: 'Do you offer team pricing?',
            answer: 'Yes! Contact us for team and brokerage pricing. We offer volume discounts for teams of 5 or more users.'
        },
        {
            question: 'Is my data secure?',
            answer: 'We use bank-level encryption and are fully compliant with industry security standards. Your data is always protected.'
        },
        {
            question: 'What integrations are included?',
            answer: 'All integrations are included in our pricing. Connect with Salesforce, Gmail, DocuSign, and many more at no extra cost.'
        }
    ];

    return (
        <div className="pricing-page">
            {/* Hero */}
            <section className="pricing-hero">
                <div className="container">
                    <span className="badge">Pricing</span>
                    <h1 className="pricing-hero__title">
                        Simple, Transparent Pricing
                    </h1>
                    <p className="pricing-hero__subtitle">
                        No hidden fees. No surprises. Just powerful AI tools to help you close more deals.
                    </p>
                </div>
            </section>

            {/* Pricing Card */}
            <section className="pricing-main section">
                <div className="container">
                    <div className="pricing-card">
                        <div className="pricing-card__badge">Most Popular</div>
                        <div className="pricing-card__header">
                            <h2 className="pricing-card__name">Professional</h2>
                            <div className="pricing-card__price">
                                <span className="pricing-card__amount">$10</span>
                                <span className="pricing-card__period">/user/month</span>
                            </div>
                            <p className="pricing-card__description">
                                Everything you need to automate your real estate transactions.
                            </p>
                        </div>

                        <ul className="pricing-card__features">
                            {features.map((feature, index) => (
                                <li key={index}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    {feature}
                                </li>
                            ))}
                        </ul>

                        <Link to="/#signup" className="btn btn-primary btn-lg pricing-card__cta">
                            Start Your Free Trial
                        </Link>
                        <p className="pricing-card__note">14-day free trial • No credit card required</p>
                    </div>

                    <div className="pricing-enterprise">
                        <div className="pricing-enterprise__content">
                            <h3 className="pricing-enterprise__title">Need Enterprise Features?</h3>
                            <p className="pricing-enterprise__description">
                                Looking for custom integrations, dedicated support, or team pricing?
                                Let's talk about how we can support your brokerage or team.
                            </p>
                        </div>
                        <Link to="/contact" className="btn btn-secondary">
                            Contact Sales
                        </Link>
                    </div>
                </div>
            </section>

            {/* Founding Member Offer */}
            <section className="founding-offer">
                <div className="container">
                    <div className="founding-offer__card">
                        <span className="founding-offer__badge">Limited Time Offer</span>
                        <h2 className="founding-offer__title">
                            Become a Founding Member
                        </h2>
                        <p className="founding-offer__description">
                            Join our first 300 users and lock in $10/month pricing forever,
                            plus get exclusive benefits including priority access to new features
                            and direct input on our product roadmap.
                        </p>
                        <Link to="/#signup" className="btn btn-primary btn-lg">
                            Join the Waitlist
                        </Link>
                    </div>
                </div>
            </section>

            {/* FAQs */}
            <section className="pricing-faqs section">
                <div className="container">
                    <h2 className="section-title">Frequently Asked Questions</h2>
                    <div className="faqs__grid">
                        {faqs.map((faq, index) => (
                            <div key={index} className="faq-card">
                                <h3 className="faq-card__question">{faq.question}</h3>
                                <p className="faq-card__answer">{faq.answer}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="pricing-cta">
                <div className="container">
                    <h2 className="pricing-cta__title">Ready to Get Started?</h2>
                    <p className="pricing-cta__subtitle">
                        Start your free trial today and see how Deal to Close AI can transform your workflow.
                    </p>
                    <Link to="/#signup" className="btn btn-primary btn-lg">
                        Start Free Trial
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Pricing;
